import Phaser from 'phaser';
import { BootScene } from './render/BootScene';
import { GameScene } from './render/GameScene';

new Phaser.Game({
  type: Phaser.AUTO,
  parent: 'game',
  backgroundColor: '#1b2a1f',
  scale: {
    mode: Phaser.Scale.RESIZE,
    width: '100%',
    height: '100%',
  },
  input: {
    activePointers: 3, // pan + pinch later
  },
  banner: false,
  scene: [BootScene, GameScene],
});
